module.exports = __webpack_public_path__ + "static/about-us-poster-80fe70e6a11cc6fb8249ce9699b2173c.png";